module.exports = __webpack_public_path__ + "static/media/bark1080.19339de0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/background/bark1080.jpg
// module id = 1347
// module chunks = 0